import _ from 'lodash';
import { LOANS } from 'loans.module/common/domain/constants.loans';
import { LOANS_CATALOG_MODAL_COACHMARK_CONFIG } from 'loans.module/common/domain/constants.loans';

class LoansCatalogController {

  constructor($log, $window, loansStaticService, LoansUserDataService, LoansOperationsService, loadingMobileService) {
    'ngInject';
    this.log = $log;
    this.loansStaticService = loansStaticService;
    this.loansUserDataService = LoansUserDataService;
    this.loansOperationsService = LoansOperationsService;
    this.loadingMobileService = loadingMobileService;

    this.userId = this.loansUserDataService._employee.userId;
    this.coachmarkData = LOANS_CATALOG_MODAL_COACHMARK_CONFIG;
    this.isMobileApp = $window.innerWidth < 1024;

    this.init();
  }

  init() {
    this.loadingMobileService.show();
    this.loansOperationsService.getCreditworthiness(this.userId)
      .then(creditworthiness => {
        this.creditworthiness = creditworthiness;
        this.loans = this.checkWhatLoansAreAvailable(creditworthiness);
        this.emptyCatalog = this.loans.length === 0;
        this.loaded = true;
      }, error => {
        this.log.error('LoansCatalogController init()', error);
        // TODO: [Manu] eliminado ya que en la APP se ve un instante antes de redirigir a login, e incluso pueda causar otros problemas. Ver si en la Web es necesario o con el errorInterceptor es suficiente
        // this.state.go(STATES.ERROR);
      }).finally(()=> {
        this.loadingMobileService.hide();
      });
  }

  checkWhatLoansAreAvailable(creditworthiness) {
    const availableLoans = Object.keys(creditworthiness);
    const order = [
      LOANS.ID.FIVE_MONTH,
      LOANS.ID.NINE_MONTH,
      LOANS.ID.VARIOUS_CREDIT,
      LOANS.ID.DIVERSAL_ATENTION,
      LOANS.ID.AGREEMENT_HOUSING_LOAN,
      LOANS.ID.SOCIAL_HOUSING_LOAN,
    ];

    const loans = _.compact(order.map(loanId => {
      if (availableLoans.includes(loanId)) {
        let loan = this.loansStaticService.get(loanId);
        loan.maximumLimit = creditworthiness[loanId].maximumLimit;
        return loan;
      }
    }));

    return loans;
  }

}

export default LoansCatalogController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansCatalog/loansCatalog.controller.js